export default __webpack_public_path__ + "static/media/rogers-blue.83ae90ef.png";